import { Injectable } from "@angular/core";
import { Router } from "@angular/router";


@Injectable({
    providedIn: 'root'
})

export class LoginLogoutService {

    
  isLoggedIn: boolean = false

  constructor(private router: Router) {
    // Start listening to storage events
    //this.start()
  }

public login = () => {
    // Do the APIs For Auth
    this.isLoggedIn = true 
 
  }

  public logOut = () => {
    // Do the APIs For Auth
    this.isLoggedIn = false 

    // Route to login page
    this.router.navigate(['/login']).then(() => {
      window.location.reload();
    });
  }

  // Bind the eventListener
  // private start(): void {
  //  // window.addEventListener("storage", this.storageEventListener.bind(this));
  // }

  // Logout only when key is 'logout-event'
  private storageEventListener(event: StorageEvent) {
    if (event.storageArea == localStorage) {
      if (event?.key && event.key == 'logout-event') {
        this.logOut();
        
      }
    }
  }

  // Handle active listeners when onDestroy 
  private stop(): void {
    window.removeEventListener("storage", this.storageEventListener.bind(this));
  }

  ngOnDestroy() {
    this.stop()
  }
}  